// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ccqxkawimemwnpjnjmfk.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNjcXhrYXdpbWVtd25wam5qbWZrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjcxMzk1MjIsImV4cCI6MjA4MjcxNTUyMn0.anfkL4BrvqkgUV91S5ExHx9bqoTmM9K-vW3wSZ2Axbc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});